module.exports = __webpack_public_path__ + "src/app/images/turn_right.svg";